import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import Html from './html';
import shared from './shared';
import methodModel from '../../methods/methods';

function NotificationManagement() {
  const searchState = { data: '' };
  const [filters, setFilter] = useState({ page: 1, count: 10, search: '' });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(true);
  const[selectedMessage ,setSelectedMessage]=useState (null)
  const [isModalVisible, setIsModalVisible] = useState(false);
  
  const history = useNavigate();

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data });
    getData({ search: searchState.data, page: 1 });
  }, []);

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key == key && filters.sorder == 'asc') cls = 'fa-sort-up';
    else if (filters.key == key && filters.sorder == 'desc') cls = 'fa-sort-down';
    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters?.key == key) {
      if (filters?.sorder == 'asc') {
        sorder = 'desc';
      } else {
        sorder = 'asc';
      }
    }
    const sortBy = `${key} ${sorder}`;
    setFilter({
      ...filters, sortBy, key, sorder,
    });
    getData({ sortBy, key, sorder });
  };
  console.log(filters ,"-----filters")

  const getData = (p = {}) => {
    let param = { ...filters, ...p };
    console.log("p: ", p)
    setLoader(true);
    loader(true)
    ApiClient.get(shared.listApi, param).then((res) => {
      if (res.success) {
        setData(res.data.map((itm) => {
          itm.id = itm?._id || itm?.id;
          return itm;
        }));
        setTotal(res.total);
      }
      loader(false)
      setLoader(false);
    });
  };

  const clear = () => {
    const f = {
      search: '',
      page: 1,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const filter = (p = {}) => {
    const f = { page: 1, ...p };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const deleteItem = (id) => {
    methodModel.DeleteData(shared.deleteApi, id, shared.addTitle, getData);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };
  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  };

  const openModal = (id)=>{
    console.log("here is id",id)
    const noti = data.find((itm)=>itm._id === id || itm.id===id);
    console.log("here is noti",noti)
    setSelectedMessage(noti)
    setIsModalVisible(true)
  }
   const closeModal = () => {
    setIsModalVisible(false);
    setSelectedMessage(null);
  };

  const changestatus = (e, type = null) => {
    console.log("e and type: ", e, type)
    // console.log("only e",e?.length)
    if (e?.length===0 ) {
      // console.log("else")
      // console.log(filters)
      // setFilter({ count:10, search:"", page: 1 });
      setFilter((prev)=>({...prev,page:1,count:10, venueIds: ""}));
      getData({ count:10, search:"", page: 1, venueIds: "" });
      return
    }
    if (type) {
      // console.log("if type")
      // setFilter({ ...filters, [type]: e, page: 1 });
      setFilter((prev)=>({...prev, [type]:e, page:1, count:10}));

      getData({ [type]: e, page: 1, count:10 });
    } 
  };

  const statusChange = (itm) => {
    methodModel.StatusChange(shared.statusApi, itm, shared.addTitle, getData)
  };

  const edit = (id) => {
    history(`/${shared.url}/edit/${id}`);
  };

  const view = (id) => {
    const url = `/${shared.url}/detail/${id}`;
    history(url);
  };

  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      deleteItem={deleteItem}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={loaging}
      data={data}
      total={total}
      statusChange={statusChange}
      openModal={openModal}
      selectedMessage={selectedMessage}
      closeModal={closeModal}
      isModalVisible={isModalVisible}
      changestatus={changestatus}
    />
  );
}

export default NotificationManagement;
